import TMNLoader from '@/assets/TMN_loader.gif';
import styles from './index.less';

const PageLoader = ({
  description,
  code,
}: {
  description?: React.ReactNode;
  code?: string;
}) => (
  <div className={styles.container}>
    <img src={TMNLoader} className={styles.loadingIcon} />
    {description && <div className={styles.description}>{description}</div>}
    {code && <div className={styles.code}>{code}</div>}
  </div>
);

export default PageLoader;
